/**
 * PromoTix sets the marketplace handoff cookie on `.promotix.com` because
 * promosuite.concurrent-development.promotix.com and reseller-stg.promotix.com
 * share no narrower parent. That domain is also sent to reseller.promotix.com.
 * Production reads only `auth_token`. Staging must use a different name so a
 * staging session is not presented to the production marketplace.
 */
export const PRODUCTION_SELLER_AUTH_COOKIE = 'auth_token';
export const STAGING_SELLER_AUTH_COOKIE = 'auth_token_stg';
export const STAGING_RESELLER_HOST = 'reseller-stg.promotix.com';

export function sellerAppAuthCookieName(hostname) {
  const host = String(hostname || '')
    .trim()
    .toLowerCase()
    .replace(/\.$/, '');
  if (host === STAGING_RESELLER_HOST) return STAGING_SELLER_AUTH_COOKIE;
  return PRODUCTION_SELLER_AUTH_COOKIE;
}
